import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import creditCardIcon from "../../../../assets/icons/CreditCardIcon.svg";

export type AdvertiserCardInfo = {
  hasCard: boolean;
  last4?: string;
  brand?: string;
  friendlyName?: string;
};

type AdvertiserCardCellProps = {
  card: AdvertiserCardInfo;
};

const Root = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 10,
  minWidth: 120,
});

const Icon = styled("img")({
  width: 20,
  height: 16,
  flexShrink: 0,
});

const CardDetails = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
});

const CardNumber = styled("span")(({ theme }: { theme: Theme }) => ({
  fontSize: 13,
  fontWeight: 600,
  color: theme.palette.brand.green,
  whiteSpace: "nowrap",
}));

const NoCardText = styled("span")(({ theme }: { theme: Theme }) => ({
  fontSize: 13,
  fontWeight: 600,
  color: theme.palette.brand.errorRed,
  whiteSpace: "nowrap",
}));

const FriendlyName = styled("span")(({ theme }: { theme: Theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.brand.gray700,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

const AdvertiserCardCell: FC<AdvertiserCardCellProps> = ({ card }) => (
  <Root>
    <Icon src={creditCardIcon} alt="" aria-hidden />
    <CardDetails>
      {card.hasCard && card.last4 ? (
        <>
          <CardNumber>* * * * {card.last4}</CardNumber>
          {card.friendlyName ? <FriendlyName>{card.friendlyName}</FriendlyName> : null}
        </>
      ) : (
        <NoCardText>No Card</NoCardText>
      )}
    </CardDetails>
  </Root>
);

export default AdvertiserCardCell;
